/*
  Input: (This is the rule format as used for redux key "common.appliedFilters[0].rule")
  =======
  [
    [
      {
        "field": "GEO_DMA",
        "value": "602",
        "display": "Chicago",
        "key": null,
        "op": "eq"
      },
      {
        "field": "GEO_DMA",
        "value": "807",
        "display": "San Francisco - Oakland - San Jose",
        "key": null,
        "op": "eq"
      },
      {
        "field": "GEO_DMA",
        "value": "504",
        "display": "Philadelphia",
        "key": null,
        "op": "eq"
      },
      {
        "field": "GEO_DMA",
        "value": "511",
        "display": "Washington DC (Hagerstown)",
        "key": null,
        "op": "eq"
      }
    ]
  ]

  Output:
  ========
  {
    "Chicago": {
      "field": "GEO_DMA",
      "value": "602",
      "display": "Chicago",
      "key": null,
      "op": "eq"
    },
    "San Francisco - Oakland - San Jose": {
      "field": "GEO_DMA",
      "value": "807",
      "display": "San Francisco - Oakland - San Jose",
      "key": null,
      "op": "eq"
    },
    "Philadelphia": {
      "field": "GEO_DMA",
      "value": "504",
      "display": "Philadelphia",
      "key": null,
      "op": "eq"
    },
    "Washington DC (Hagerstown)": {
      "field": "GEO_DMA",
      "value": "511",
      "display": "Washington DC (Hagerstown)",
      "key": null,
      "op": "eq"
    }
  }
*/

/* eslint-disable no-underscore-dangle, no-param-reassign */
// Used when applying saved filters in the UI
// preserves AND or OR as per customer's definition
const getFlexibleRule = (filter) => {
  const rulesObj = {};
  filter.forEach((rule, index) => {
    if (rule && rule.length > 0) {
      rule.forEach((orRule, index1) => {
        const filterName = `${orRule.display}$$${index}_${index1}`;
        orRule._order = index;
        rulesObj[filterName] = orRule;
      });
    }
  });
  return rulesObj;
};
/* eslint-enable no-underscore-dangle, no-param-reassign */

const getRule = (filter) => Object.fromEntries(filter.flat().map((rule) => [rule.display, rule]));

const getRulesFromAppliedFilter = (filter, flexible = false) =>
  flexible ? getFlexibleRule(filter) : getRule(filter);

export default getRulesFromAppliedFilter;
